import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Container } from '@material-ui/core';
import { useStyles } from './styles';
import { EndUserDashboardProfile } from 'components/DashBoardBlocks/LeftTabsBlock/TabsContent/AdminUserProfile/EndUserDashboardProfile';

const EndUserDashboard: FC = observer(() => {
  const classes = useStyles();
  return (
    <Container maxWidth='xl' className={classes.container}>
      <EndUserDashboardProfile />
    </Container>
  );
});

export default EndUserDashboard;
